module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-right-short-e6c47cbd.svg";